import { AppThunk } from "@Store/index";
import { fetchAmberPLusPageDataIfNeeded } from "./amberPlusPageReducer";

const loadData = (props: any): AppThunk[] => [
  fetchAmberPLusPageDataIfNeeded(props),
  // More pre-fetched actions...
];

export default loadData;
